import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity5 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_5;
}

export default GravelRoadTileEntity5;
